import { SignIn } from "@clerk/clerk-react";
import markGradient from "../brand/assets/mark-gradient.png";

// Full-page sign-in shown to signed-out visitors when Clerk auth is enabled.
// Wraps Clerk's <SignIn/> in Mockingbird chrome and themes it to the brand.
export function SignInScreen() {
  return (
    <div className="auth-screen">
      <div className="auth-card">
        <div className="auth-brand">
          <img src={markGradient} width={44} height={44} alt="" aria-hidden="true" />
          <span className="auth-wordmark">MOCKINGBIRD</span>
        </div>
        <p className="auth-tag">Line up every audio file with the manuscript — and catch every flub.</p>
        <SignIn
          routing="hash"
          signUpUrl="/sign-up"
          appearance={{
            variables: {
              colorPrimary: "#7c3aed",
              borderRadius: "12px",
              fontFamily: "'Hanken Grotesk', system-ui, sans-serif",
            },
            elements: {
              rootBox: "auth-clerk-root",
              card: "auth-clerk-card",
            },
          }}
        />
      </div>
      <div className="auth-foot muted">Invite-only beta · Mockingbird</div>
    </div>
  );
}
